/**
 * Digits nobody dials: one digit repeated (00000000000, 11111111111) or a straight
 * run (12345678901, 98765432109). `isPossible` accepts both because they have the right
 * length, and the professional signup audit (2026-10-03) created an account with a WhatsApp
 * of all zeros. Mirrored in the API (`common/phone.ts`); keep the two in step.
 *
 * Alias-free module (no `@/` imports) so `node --test` can load it directly.
 */
export function isPlaceholderDigits(digits: string): boolean {
  if (digits.length < 8) return false;
  if (/^(\d)\1+$/.test(digits)) return true;
  const run = (step: 1 | -1) =>
    [...digits].every(
      (d, i) => i === 0 || (Number(d) - Number(digits[i - 1]) + 10) % 10 === (step + 10) % 10,
    );
  return run(1) || run(-1);
}
